module.exports = __webpack_public_path__ + "img/BAWS_Polearm2_2_2.a4cad46e.png";